import React, { forwardRef } from "react";
import SectionHeader from "./Section/SectionHeader";
import Section from "./Section/Section";
import Card from "./Card";

const Testimonial = forwardRef((props, ref) => {
  const content = [
    {
      src: "/assets/profile01.webp",
      title: "Keyword Research",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur et facilis illo impedit sit tenetur.",
    },
    {
      src: "/assets/profile02.webp",
      title: "SEO Consultancy",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur et facilis illo impedit sit tenetur.",
    },
    {
      src: "/assets/profile03.webp",
      title: "Marketing",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur et facilis illo impedit sit tenetur.",
    },
  ];
  return (
    <Section id="testimonial" ref={ref}>
      <SectionHeader
        title={"Testimonial"}
        content={"Lorem ipsum dolor sit amet, consectetur adipisicing elit."}
      />
      {content.map((item) => (
        <Card center key={item.title}>
          <figure className="overflow-hidden w-full w-24 h-24">
            <img className="object-cover " src={item.src} alt={item.title} />
          </figure>
          <h3 className="px-4 text-2xl font-serif text-indigo-800 font-bold">
            {item.title}
          </h3>
          <p className="px-4 text-sm text-slate-500 text-center">
            {item.content}
          </p>
        </Card>
      ))}
    </Section>
  );
});

export default Testimonial;
